/**
 * ImageNet 狗类 index (151–268) → 中文品种名
 * 来源: tfjs-models/mobilenet imagenet_classes，与 plan 中 Stanford Dogs 思路对齐
 */
export const IMAGENET_DOG_INDEX_TO_ZH: Record<number, string> = {
  151: '吉娃娃',
  152: '日本 spaniel',
  153: '马尔济斯',
  154: '京巴',
  155: '西施犬',
  156: '布伦海姆 spaniel',
  157: '蝴蝶犬',
  158: '玩具梗',
  159: '罗得西亚脊背犬',
  160: '阿富汗猎犬',
  161: '巴吉度',
  162: '比格犬',
  163: '寻血猎犬',
  164: '蓝 tick 猎犬',
  165: '黑褐猎浣熊犬',
  166: '沃克猎犬',
  167: '英国猎狐犬',
  168: '红骨猎犬',
  169: '俄罗斯狼犬',
  170: '爱尔兰狼犬',
  171: '意大利灵缇',
  172: '惠比特',
  173: '伊比沙猎犬',
  174: '挪威猎鹿犬',
  175: '水獭猎犬',
  176: '萨路基',
  177: '苏格兰猎鹿犬',
  178: '魏玛犬',
  179: '斯塔福斗牛梗',
  180: '美国斯塔福梗',
  181: '贝灵顿梗',
  182: '边境梗',
  183: '凯利蓝梗',
  184: '爱尔兰梗',
  185: '诺福克梗',
  186: '诺里奇梗',
  187: '约克夏梗',
  188: '刚毛猎狐梗',
  189: '湖畔梗',
  190: '西里汉梗',
  191: '万能梗',
  192: '凯恩梗',
  193: '澳大利亚梗',
  194: '丹迪丁蒙梗',
  195: '波士顿梗',
  196: '迷你雪纳瑞',
  197: '巨型雪纳瑞',
  198: '标准雪纳瑞',
  199: '苏格兰梗',
  200: '西藏梗',
  201: '丝毛梗',
  202: '软毛麦色梗',
  203: '西高地白梗',
  204: '拉萨犬',
  205: '平毛寻回犬',
  206: '卷毛寻回犬',
  207: '金毛寻回犬',
  208: '拉布拉多寻回犬',
  209: '切萨皮克湾寻回犬',
  210: '德国短毛指示犬',
  211: '维兹拉犬',
  212: '英国塞特犬',
  213: '爱尔兰塞特犬',
  214: '戈登塞特犬',
  215: '布列塔尼猎犬',
  216: '克伦伯犬',
  217: '英国史宾格',
  218: '威尔士史宾格',
  219: '可卡犬',
  220: '苏塞克斯猎犬',
  221: '爱尔兰水猎犬',
  222: '库瓦兹犬',
  223: '舒柏奇犬',
  224: '比利时格罗安达犬',
  225: '马利诺斯犬',
  226: '伯瑞犬',
  227: '澳大利亚卡尔比犬',
  228: '可蒙犬',
  229: '古代英国牧羊犬',
  230: '喜乐蒂牧羊犬',
  231: '柯利犬',
  232: '边境牧羊犬',
  233: '法兰德斯牧牛犬',
  234: '罗威纳',
  235: '德国牧羊犬',
  236: '杜宾犬',
  237: '迷你杜宾',
  238: '大瑞士山地犬',
  239: '伯恩山犬',
  240: '阿彭策尔犬',
  241: '恩特布彻犬',
  242: '拳师犬',
  243: '斗牛獒',
  244: '藏獒',
  245: '法国斗牛犬',
  246: '大丹犬',
  247: '圣伯纳',
  248: '爱斯基摩犬',
  249: '阿拉斯加雪橇犬',
  250: '西伯利亚哈士奇',
  251: '斑点犬',
  252: '猴面犬',
  253: '巴仙吉犬',
  254: '巴哥犬',
  255: '莱昂伯格犬',
  256: '纽芬兰犬',
  257: '大白熊犬',
  258: '萨摩耶',
  259: '博美',
  260: '松狮',
  261: '荷兰毛狮犬',
  262: '布鲁塞尔格里芬犬',
  263: '彭布罗克威尔士柯基',
  264: '卡迪根威尔士柯基',
  265: '玩具贵宾',
  266: '迷你贵宾',
  267: '标准贵宾',
  268: '墨西哥无毛犬',
};

const DOG_INDEX_MIN = 151;
const DOG_INDEX_MAX = 268;

export function isDogClassIndex(index: number): boolean {
  return index >= DOG_INDEX_MIN && index <= DOG_INDEX_MAX;
}

export function imagenetDogIndexToZh(index: number): string {
  return IMAGENET_DOG_INDEX_TO_ZH[index] ?? `犬类 #${index}`;
}
